import React from 'react';
import { useQuery } from '@apollo/client';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

type result = {
  loading: boolean;
  dietSettingsData?: any;
};

interface IDietSettingsConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  query: any;
}

export const DietSettingsConnectorApollo: React.FC<IDietSettingsConnectorApolloProps> = ({
  children,
  query,
}) => {
  const today = formatIsoDate(new Date());
  const { loading, data, error } = useQuery(query, {
    variables: { date: today },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.dietSettingsData = data;
  }

  return children(result);
};

export default DietSettingsConnectorApollo;
